import image1 from "../assets/Inicio/Azul-Valdez-clienta.png";
import image2 from "../assets/Inicio/Flor-Ponce-Colega.png";
import image3 from "../assets/Inicio/Gisela-Rodriguez-Clienta.png";
import image4 from "../assets/Inicio/Rodrigo-Arbé.png";

const Testimonials = [
    {
        image: image1,
        description: "Me encanta ir al estudio de Sandra, siempre me recibe con música agradable, unas velitas encendidas, caramelera con cosas ricas, cuida mucho cada detalle para hacerte sentir bien",
        name: "AZUL VALDEZ",
        roll: "Clienta",
    },
    {
        image: image2,
        description: "Es una persona comprometida con su profesión, super humana, cálida y confiable, además de la excelente persona que es Sandri.",
        name: "Florencia Ponce",
        roll: "Colega",
    },
    {
        image: image3,
        description: "Super atenta y profesional a la hora de maquillarme. Me sentí muy a gusto y logró entender lo que yo buscaba para mi make up",
        name: "Gisela Rodriguez",
        roll: "Clienta",
    },
    {
        image: image4,
        description: "Mis cejitas siempre están bellas y prolijas gracias a las manos de Sandra, siempre trabaja con profesionalismo y productos de primera línea.",
        name: "Rodrigo Arbé",
        roll: "Cliente",
    }
]


export default Testimonials